// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class GetChatAccountLocality
{
    chatId: string;
    accountNumber: string;
}